// extracted by mini-css-extract-plugin
export default {"wrapper":"Value_wrapper__4v0F4","iconWrapper":"Value_iconWrapper__hacqg","low":"Value_low__ZYoWW","high":"Value_high__RHeK9"};